<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title class="hidden-sm-and-down">Рассылка</v-toolbar-title>
                    <EventButtonsInFooter
                            :messageModel="mailingModel"
                            :visibleButtons="{chainBlock: 0, moduleBlock: 0, findWordBlock: 0}"
                            @visKeyboardForm="visKeyboardForm=true"
                            @visAttachmentForm="visAttachmentForm=true"
                            @jumpInfoDialog="jumpInfoDialog=true"
                            v-if="edit === true"
                    ></EventButtonsInFooter>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <test-message-sender
                                :modelId="mailingModel.id"
                                :typeModel="'mailing'"
                                @testMessageSenderNotification="testMessageSenderNotification"
                        ></test-message-sender>
                        <v-btn dark text @click="saveValue" v-if="edit" :disabled="!this.valid || mainValid">
                            <v-icon>save</v-icon>
                            <span class="hidden-sm-and-down">{{mailingModel.id === null ? ' Создать' : ' Сохранить'}}</span>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container>
                        <v-form ref="form" v-model="valid">
                            <v-row>
                                <v-col cols="11" class="py-0">
                                    <v-text-field
                                            v-model="mailingModel.title"
                                            :counter="35"
                                            label="Название рассылки"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 pr-0 mr-0"
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="1" class="py-0 ma-0 pa-0" align-self="center" justify="start">
                                    <tooltip-icon color="none" :top="true" v-html="true"
                                                  text="Таргетированная рассылка отправляется всем пользователям.<br>
                                                  Групповая рассылка отправляется только пользователям
                                                  выбранных групп. <br>Так же можно выбрать группы исключения"/>
                                </v-col>
                                <v-col cols="12" class="py-0 px-3">
                                    <date-time-picker
                                            v-model="date"
                                            language="ru"
                                            format="YYYY-MM-DD HH:mm"
                                            label="Время и дата отправки сообщений"
                                            :noClearButton="true"
                                            :noHeader="true"
                                            :min-date="minDate"
                                            @input="inputDatePicker"
                                    ></date-time-picker>
                                </v-col>
                                <v-col cols="12" xs12 class="py-2 px-7">
                                    <v-row no-gutters>
                                        <v-col cols="4" sm="3" md="3" lg="3" style="flex-wrap: nowrap">
                                            <span style="white-space: nowrap;" class="pr-1">Платформа:</span>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-btn-toggle v-model="mailingModel.platform" mandatory>
                                                <v-btn text value="vk" small color="primary"
                                                       :disabled="!accessPlatform.vk">
                                                    Вконтакте
                                                </v-btn>
                                                <v-btn text value="tg" small color="primary"
                                                       :disabled="!accessPlatform.tg">
                                                    Telegram
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="10" md12 class="py-0 px-7">
                                    Тип рассылки:
                                    <v-btn-toggle v-model="mailingModel.type_list" mandatory>
                                        <v-btn text :value="1" small :disabled="!edit" color="primary">
                                            <span class="text-capitalize">Групповая</span>
                                        </v-btn>
                                        <v-btn text :value="2" small :disabled="!edit" color="primary">
                                            <span class="text-capitalize">Всем</span>
                                        </v-btn>
                                    </v-btn-toggle>
                                </v-col>
                                <v-col cols="1" md2 class="ma-0 pa-0" v-if="mainValid">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-icon v-on="on" color="error">error</v-icon>
                                        </template>
                                        <span>Выберите группы</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col v-if="mailingModel.type_list === 1"
                                       cols="12" md12 class="py-0 px-7"
                                >
                                    <MailingGroupsPicker
                                            :selectedMailingGroups="selectedMailingGroups.group_ids"
                                            :mailingGroups="mailingGroups"
                                            :edit="edit"
                                            @updateGroups="updateGroups"
                                    ></MailingGroupsPicker>
                                </v-col>
                                <br>
                                <v-col cols="12" md12 class="py-0">
                                    <v-textarea
                                            auto-grow
                                            rows="3"
                                            name="input-7-1"
                                            :counter="3000"
                                            v-model="mailingModel.text"
                                            label="Текст"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 my-0 py-0"
                                            :rules="[rules.maxLengthText]"
                                    ></v-textarea>
                                </v-col>
                                <v-col v-show="bot && bot.theme_id === 2" cols="12">
                                    <v-col cols="12" md12 class="py-0">
                                        <v-text-field
                                            v-model="mailingModel.car_model"
                                            :counter="35"
                                            label="Фильтр по модели автомобилей"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 pr-0 mr-0"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md12 class="py-0">
                                        <v-text-field
                                            v-model="mailingModel.car_number"
                                            :counter="35"
                                            label="Фильтр по гос. номерам автомобилей"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 pr-0 mr-0"
                                        ></v-text-field>
                                    </v-col>
                                    <v-row>
                                    <v-col cols="6" class="py-0">
                                        <v-text-field
                                            v-model="mailingModel.count_order"
                                            :counter="35"
                                            label="Количество ордеров"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 pr-0 mr-0"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="6" class="py-0" v-show="mailingModel.count_order !== null && mailingModel.count_order !== ''">
                                        <v-select
                                            v-model="mailingModel.count_order_period"
                                            :items="[{text:'Месяц', value: 1}, {text:'Полгода', value: 6}, {text:'Год', value: 12}]"
                                            :counter="35"
                                            label="Период"
                                            :readonly="!edit"
                                            class="ma-2 pa-2 pr-0 mr-0"
                                        ></v-select>
                                    </v-col>
                                    </v-row>
                                </v-col>

                                <v-col cols="12" md12 class="py-0 px-7">
                                    <media-library-block :attachments="attachments"/>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MessageButtonViewer
                                            :edit="edit"
                                            :modelKeyboardId="mailingModel.keyboard_id"
                                    ></MessageButtonViewer>
                                </v-col>

                                <v-col cols="12" md12 class="py-0 px-7">
                                    <v-switch v-model="mailingModel.jump_checker" inset
                                              label="Подсчет нажатий по ссылкам" color="primary"
                                              :false-value="0"
                                              :true-value="1"
                                              hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <v-switch v-model="mailingModel.dont_parse_links"
                                              inset
                                              label="Не парсить ссылки"
                                              color="primary"
                                              :false-value="0"
                                              :true-value="1"
                                              hide-details
                                    ></v-switch>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 px-7">
                                    <MailingGroupsPicker
                                            newLabel="Кроме групп"
                                            newFieldName="excepts"
                                            :selectedMailingGroups="selectedMailingGroups.excepts"
                                            :mailingGroups="mailingGroups"
                                            :edit="edit"
                                            @updateGroups="updateGroups"
                                    ></MailingGroupsPicker>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <KeyboardForm :visible="visKeyboardForm" :keyboards="keyboards" :keyboardId="mailingModel.keyboard_id"
                      :messageModel="mailingModel"
                      @close="visKeyboardForm=false"
                      @selectKeyboard="selectKeyboard"
                      @removeKeyboard="removeKeyboard"
        ></KeyboardForm>
        <attachment-form :visible="visAttachmentForm"
                         :obj-type="3"
                         :model="mailingModel" @close="visAttachmentForm=false"
                         @updateAttachment="updateAttachment"
        ></attachment-form>
        <jump-info-dialog :visible="jumpInfoDialog"
                          :model="mailingModel"
                          :type="2"
                          @close="jumpInfoDialog=false"
        ></jump-info-dialog>
        <v-snackbar
                v-model="snackbarParams.show"
                bottom
                :color="snackbarParams.color"
                right
        >
            {{snackbarParams.text}}
            <v-btn
                    dark
                    text
                    @click="snackbarParams.show = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import MailingGroupsPicker from './MailingGroupsPicker'
import KeyboardForm from '../message/KeyboardForm'
import MessageButtonViewer from '../message/MessageButtonViewer'
import MediaLibraryBlock from '../message/MediaLibraryBlock'
import AttachmentForm from '../message/MediaLibrarySelectBox'
import EventButtonsInFooter from '../event/EventButtonsInFooter'
import JumpInfoDialog from '../jump/JumpInfoDialog'
import { mapGetters } from 'vuex'
import timeHelpers from '../../../scripts/helpers/timeHelpers'
import DateTimePicker from 'vue-ctk-date-time-picker'
import TooltipIcon from '../../TooltipIcon'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import TestMessageSender from '../message/TestMessageSender'

export default {
    name: 'MailingForm',
    props: ['mailings', 'index', 'dialog', 'edit'],

    components: {
        KeyboardForm,
        MessageButtonViewer,
        MailingGroupsPicker,
        MediaLibraryBlock,
        AttachmentForm,
        EventButtonsInFooter,
        JumpInfoDialog,
        DateTimePicker,
        TooltipIcon,
        TestMessageSender,
    },
    data() {
        return {
            show: false,
            isActive: false,
            mailingModel: { id: null },
            selectedMailingGroups: { excepts: [], group_ids: [] },
            visKeyboardForm: false,
            keyboardModelDef: {
                id: null,
                title: 'Кнопка',
                bot_id: null,
                one_time: 1,
                hotkey: 0,
                visible: 1,
                struct: '{}'
            },
            keyboardModel: {
                id: null
            },
            messages: [],
            attachments: [],
            visAttachmentForm: false,
            snackbarParams: {
                color: 'success',
                text: 'Успешно сохранено!',
                show: false
            },
            jumpInfoDialog: false,
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 3000) || 'Максимальная длина сообщения 500 символов.',
                maxLengthButton: value => (value.length <= 20) || 'Максимальная длина названия 20 символов.',
                urlValid: value => (value !== null ? !!value.match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9А-яЁё]+([\-\.]{1}[a-z0-9А-яЁё]+)*\.[a-zА-яЁё]{2,10}(:[0-9]{1,5})?(\/.*)?$/g) : false) || 'Ссылка имеет неверный формат. Пример верного формата https://app.chatway.ru/'
            },
            valid: false,
            date: timeHelpers.getDateFormatOutDate(new Date(), 'YYYY-MM-DD HH:mm'),
            minDate: timeHelpers.getDateFormatOutDate(new Date(), 'YYYY-MM-DD HH:mm'),
            counter: 0,
            accessPlatform: {
                'vk': false,
                'tg': false
            }
        }
    },
    methods: {
        saveValue() {
            this.mailingModel.start_time = Date.parse(this.date.replace(/-/g, '/')) / 1000
            this.$store.dispatch('mailings/saveMailing', this.mailingModel).then(response => {
                if (response.type === 'CreateResult' || response.type === 'UpdateResult') {
                    this.mailingModel.id = response.response.data.id
                    this.date = timeHelpers.getDateFormatOutDate(new Date(response.response.data.start_time * 1000), 'YYYY-MM-DD HH:mm')
                    this.snackbarParams.color = 'success'
                    this.snackbarParams.text = 'Сохранение/создание прошло успешно!'
                } else {
                    this.snackbarParams.color = 'error'
                    this.snackbarParams.text = 'Ошибка при сохранении/создании перехода'
                }
                this.snackbarParams.show = true
            })
        },
        loadModel(index = null) {
            if (index === null) {
                this.mailingModel = Object.assign({}, this.mailingModelDef)
                this.checkBotTokens()
            } else {
                this.mailingModel = Object.assign({}, this.mailings[index])
                let excepts = this.mailingModel.excepts.split(',')
                let groupIds = this.mailingModel.group_ids.split(',')
                for (let j = 0; j < this.mailingGroups.length; j++) {
                    for (let i = 0; i < groupIds.length; i++) {
                        if (parseInt(groupIds[i], 10) === this.mailingGroups[j].id) {
                            this.selectedMailingGroups.group_ids.push(this.mailingGroups[j])
                        }
                    }
                    for (let i = 0; i < excepts.length; i++) {
                        if (parseInt(excepts[i], 10) === this.mailingGroups[j].id) {
                            this.selectedMailingGroups.excepts.push(this.mailingGroups[j])
                        }
                    }
                }
                this.date = timeHelpers.getDateFormatOutDate(new Date(this.mailingModel.start_time * 1000), 'YYYY-MM-DD HH:mm')
            }
        },
        selectKeyboard(keyboardId) {
            this.mailingModel.keyboard_id = keyboardId === 0 ? null : keyboardId
            this.saveValue()
        },
        removeKeyboard(index) {
            if (this.mailingModel.keyboard_id === this.keyboards[index].id) {
                this.mailingModel.keyboard_id = null
                this.saveValue()
            }
            this.keyboards.splice(index, 1)
        },
        updateGroups(data) {
            this.selectedMailingGroups[data.field] = data.selectedMailingGroups
            this.mailingModel[data.field] = data.group_ids
            this.otherValid = !this.valid && this.mailingModel.type_list === 1 ? (this.mailingModel.group_ids.length === 0) : false
        },
        updateAttachment(data) {
            this.attachments = data.selectedItems
        },
        sendTestMessage() {
            this.$store.dispatch('mailings/sendTestMessage', this.mailingModel)
        },
        inputDatePicker() {
            if (this.counter <= 1) { // баг в библиотеке. По непонятной причине обнулял дату при первом вызове пикера
                this.date = timeHelpers.getDateFormatOutDate(timeHelpers.addHours(new Date(), 1), 'YYYY-MM-DD HH:mm') + ''
                this.counter++
            }
        },
        checkBotTokens() {
            let bot = this.getBotById(+this.$route.params['pathMatch'])
            if (bot && +bot.token_vk_mailing === 1) {
                this.accessPlatform.vk = true
            }
            if (bot && +bot.token_tg === 1) {
                this.accessPlatform.tg = true
                if (+bot.token_vk_mailing !== 1) {
                    this.mailingModel.platform = 'tg'
                }
            }
        },
        testMessageSenderNotification({ color, text }) {
            this.snackbarParams.color = color
            this.snackbarParams.text = text
            this.snackbarParams.show = true
        }
    },
    watch: {
        dialog() {
            if (this.dialog === true) {
                this.loadModel(this.index)
                this.otherValid = !this.valid && this.mailingModel.type_list === 1 ? (this.mailingModel.group_ids.length === 0) : false
                this.show = true
                if (this.mailingModel.id == null && this.index == null) {
                    let newDate = new Date()
                    newDate.setHours(newDate.getHours() + 1)
                    this.date = timeHelpers.getDateFormatOutDate(newDate, 'YYYY-MM-DD HH:mm')
                }
            } else {
                this.show = false
            }
        },
        show() {
            if (this.show === false) {
                this.selectedMailingGroups.excepts.splice(0, this.selectedMailingGroups.excepts.length)
                this.selectedMailingGroups.group_ids.splice(0, this.selectedMailingGroups.group_ids.length)
                this.mailingModel = Object.assign({}, this.mailingModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
                this.checkBotTokens()
            }
        },
        bots: {
            handler() {
                if (this.bots) {
                    this.checkBotTokens()
                }
            },
            deep: true,
            immediate: true
        },
        counter(value) {
            if (value < 3 && this.index != null) {
                this.date = timeHelpers.getDateFormatOutDate(new Date(this.mailingModel.start_time * 1000), 'YYYY-MM-DD HH:mm')
            }
        }
    },
    computed: {
        ...mapGetters({
            mailingModelDef: 'mailings/mailingModelDef',
            mailingGroups: 'mailingGroups/mailingGroups',
            keyboards: 'keyboards/keyboards',
            bots: 'bots/bots',
            getBotById: 'bots/getBotById'
        }),
        mainValid() {
            return (this.mailingModel.type_list === 1 ? (this.mailingModel.group_ids.length === 0) : false) ||
                    (!this.accessPlatform.vk && !this.accessPlatform.tg)
        },
        bot() {
            return this.getBotById(+this.$route.params['pathMatch'])
        }
    },
    created() {
        this.$store.dispatch('mailings/changeBotIdModelDefault', this.$route.params['pathMatch'])
        this.keyboardModelDef.bot_id = this.$route.params['pathMatch']
        this.mailingModel = Object.assign({}, this.mailingModelDef)
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
